import { LocationState } from '@eventbrite/discover-utils';
import { OrganicEventSearchApiPayload } from '@eventbrite/search-utils';
import { getPlaceFromCoordinates } from '@eventbrite/user-location';
import { DEFAULT_DESTINATION_EVENT_EXPANSIONS } from '../../../../constants';

export const getQuery = (
    location: LocationState,
): OrganicEventSearchApiPayload => {
    return {
        browse_surface: 'homepage',
        event_search: {
            page_size: 8,
            dates: ['current_future'],
            point_radius: {
                radius: '5mi',
                latitude: location.latitude,
                longitude: location.longitude,
            },
            online_events_only: false,
            image: true,
            available: true,
            sold_out_status: true,
            places: location.placeId ? [location.placeId] : [],
        },
        'expand.destination_event': DEFAULT_DESTINATION_EVENT_EXPANSIONS,
    };
};

export const getLocation = (setDeviceLocation: any, location: any) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                const place = await getPlaceFromCoordinates({
                    latitude,
                    longitude,
                });
                setDeviceLocation({
                    ...place,
                    currentPlace: place?.name,
                    placeId: place?.id,
                });
            },
            (err: any) => {
                console.log('err while fetching geolocation : ', err);
                setDeviceLocation(location);
            },
        );
    } else {
        console.log('geolocation not supported: ');
        setDeviceLocation(location);
    }
};
